import * as React from 'react'

function SvgEdge(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 17 17" {...props}>
			<path
				fill="currentColor"
				d="M4.524 3.632l1.828-.022v4.516l4.24.01.012-4.515 1.883.01v10.294h-1.861V9.734l-4.274.01.011 4.186h-1.85z"
			/>
		</svg>
	)
}

export default SvgEdge
